import React from 'react'

import { Dialog } from '@progress/kendo-react-dialogs';

const CustomTitleBar = ({ tikNum, vahadaData }) => {
    return (
        <div>
            <div>
                <span>{`מערכת ${vahadaData.systemName} `}</span>
                <span>|</span>
                <span>{` תיק ${tikNum} `}</span>
                <span>|</span>
                <span>{` ${vahadaData.descSugDiun}`}</span>
            </div>

            <div>
                {
                    vahadaData.descrHahlata ? 
                    <>
                        <span>
                            <b>{`${vahadaData.sugReshumaHahlata} מתאריך `}</b>
                            {`${vahadaData.taarihDiun}: ${vahadaData.descrHahlata}`}
                        </span>
                        <br />
                    </>
                        :
                        ""
                }
                <span>
                    {vahadaData.taarihTokefHahlata ? <b>{`תום תוקף החלטה: `}</b> : "" }
                    {`${vahadaData.taarihTokefHahlata ? vahadaData.taarihTokefHahlata : "" }`}
                </span>
            </div>
        </div>
    );
};

const VahadaDialog = ({ closeDialog, vahadaDialogData }) => {
    return (
        // <Dialog title={<CustomTitleBar tikNum={vahadaDialogData.tikNum} vahadaData={vahadaDialogData} />} onClose={closeDialog} width={1000} height={500} style={{ overflow: 'hidden' }}>
        <div className="dialogVaada" style={{ width: "100%", maxWidth: "700px", overflow: "auto" }} > {/* Didn't effect, why? is the Dialog have his own css?? */}
            <Dialog title={<CustomTitleBar tikNum={vahadaDialogData.tikNum} vahadaData={vahadaDialogData} />} onClose={closeDialog} > 
                <div style={{ textAlign: "right", marginLeft: "200px" }} dangerouslySetInnerHTML={{ __html: vahadaDialogData.hamhahTochen }} />
                {/* <div style={{ textAlign: "right" }} dangerouslySetInnerHTML={{ __html: vahadaDialogData.hamhahTochen }} /> */}
            </Dialog>
        </div>
        
    )
}

export default VahadaDialog;